import { z } from "zod";
import { PROTOCOL_VERSION } from "#version";

export const sdkErrorBodySchema = z.object({
	code: z.string().min(1),
	message: z.string(),
});

const baseFields = {
	v: z.literal(PROTOCOL_VERSION),
	type: z.string().min(1),
};

export const sdkEventMessageSchema = z.object({
	...baseFields,
	kind: z.literal("event"),
	payload: z.unknown(),
});

export const sdkRequestMessageSchema = z.object({
	...baseFields,
	kind: z.literal("request"),
	id: z.string().min(1),
	payload: z.unknown(),
});

export const sdkResponseOkMessageSchema = z.object({
	...baseFields,
	kind: z.literal("response"),
	id: z.string().min(1),
	ok: z.literal(true),
	payload: z.unknown(),
});

export const sdkResponseErrMessageSchema = z.object({
	...baseFields,
	kind: z.literal("response"),
	id: z.string().min(1),
	ok: z.literal(false),
	error: sdkErrorBodySchema,
});

export const sdkResponseMessageSchema = z.discriminatedUnion("ok", [sdkResponseOkMessageSchema, sdkResponseErrMessageSchema]);

export const sdkEnvelopeSchema = z.union([sdkEventMessageSchema, sdkRequestMessageSchema, sdkResponseMessageSchema]);

export type SdkEnvelopeParsed = z.infer<typeof sdkEnvelopeSchema>;
